export const MOCK_DNS_RECORDS_RESPONSE = {
  count: 5,
  total_pages: 1,
  current_page: 1,
  results: [
    { record: '93.184.216.34', record_type: 'A', domain: 'example.com' },
    { record: 'mail.example.com', record_type: 'MX', domain: 'example.com' },
    { record: 'v=spf1 include:_spf.example.com ~all', record_type: 'TXT', domain: 'example.com' },
    { record: 'ns1.example.com', record_type: 'NS', domain: 'example.com' },
    { record: 'www.example.com', record_type: 'CNAME', domain: 'example.com' },
  ],
}

export const MOCK_DNS_RECORD_FILTER_OPTIONS = {
  record_type: ['A', 'MX', 'TXT', 'NS', 'CNAME'],
  domain: ['example.com'],
}
